<template>
  <v-layout class="stats-page admin-income-container">
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-hover v-slot:default="{ hover }">
            <v-card :elevation="hover ? 2 : 0">
              <v-card-title>Ingresos por planes</v-card-title>
              <v-card-text>
                <div class="toggles hidden-print-only" v-if="planStats">
                  <v-radio-group class="mt-0" v-model="selectedPlanGroup" row>
                    <div
                      class="toggle children-inline"
                      v-for="(group, index) of planGroups"
                      :key="group"
                      :style="{
                        'border-color':
                          selectedPlanGroup === group ? colors[0] : undefined,
                        'background-color':
                          selectedPlanGroup === group
                            ? colors[0] + '22'
                            : undefined,
                      }"
                    >
                      <v-radio
                        :label="titles[group]"
                        :value="group"
                        class="mt-0 pt-0"
                        :color="colors[0]"
                        hide-details
                      />
                    </div>
                  </v-radio-group>
                </div>
                <chart-widget
                  v-if="planStats"
                  :stats="filteredPlanStats"
                  value-prefix="ARS"
                />
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-hover v-slot:default="{ hover }">
            <v-card :elevation="hover ? 2 : 0">
              <v-card-title
                >Ingresos por comisiones en Argentina (ARS)</v-card-title
              >
              <v-card-text>
                <div class="toggles hidden-print-only" v-if="orderStats">
                  <div
                    class="toggle children-inline"
                    v-for="(group, index) of orderGroups"
                    :key="group"
                    :style="{
                      'border-color': colors[index],
                      'background-color': colors[index] + '22',
                    }"
                  >
                    <span style="font-size: 1.1em">{{ titles[group] }}</span>
                  </div>
                </div>
                <chart-widget
                  v-if="orderStats"
                  :stats="filteredOrderStats"
                  value-prefix="ARS"
                />
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-hover v-slot:default="{ hover }">
            <v-card :elevation="hover ? 2 : 0">
              <v-card-title>Total pedidos en Argentina (ARS)</v-card-title>
              <v-card-text>
                <div
                  class="toggles hidden-print-only"
                  v-if="totalOrdersArsStats"
                >
                  <div
                    class="toggle children-inline"
                    v-for="(group, index) of totalOrdersGroups"
                    :key="group"
                    :style="{
                      'border-color': colors[index],
                      'background-color': colors[index] + '22',
                    }"
                  >
                    <span style="font-size: 1.1em">{{ titles[group] }}</span>
                  </div>
                </div>
                <chart-widget
                  v-if="totalOrdersArsStats"
                  :stats="totalOrdersArsStats"
                  value-prefix="ARS"
                />
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-hover v-slot:default="{ hover }">
            <v-card :elevation="hover ? 2 : 0">
              <v-card-title
                >Total pedidos fuera de Argentina (USD)</v-card-title
              >
              <v-card-text>
                <div
                  class="toggles hidden-print-only"
                  v-if="totalOrdersUsdStats"
                >
                  <div
                    class="toggle children-inline"
                    v-for="(group, index) of totalOrdersGroups"
                    :key="group"
                    :style="{
                      'border-color': colors[index],
                      'background-color': colors[index] + '22',
                    }"
                  >
                    <span style="font-size: 1.1em">{{ titles[group] }}</span>
                  </div>
                </div>
                <chart-widget
                  v-if="totalOrdersUsdStats"
                  :stats="totalOrdersUsdStats"
                  value-prefix="USD"
                />
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import StatsService from '../../../api/services/stats.service';
  import { IStats } from '../../../interfaces/IStats';
  import ChartWidget from '../../widgets/ChartWidget.vue';
  import { padNumber } from '../../../utils';
  import { IStatGroup } from '../../../interfaces/IStatGroup';
  @Component({
    components: { ChartWidget },
  })
  export default class IncomeDashboard extends Vue {
    statsService = new StatsService();
    planStats: IStats = null;
    orderStats: IStats = null;
    planGroups = ['total', 'count', 'average'];
    selectedPlanGroup = 'total';
    orderGroups = ['total', 'count', 'average'];
    titles = {
      total: 'Total',
      count: 'Cantidad',
      average: 'Promedio',
    };
    colors = ['#45a5f5', '#30d565', '#f5e938'];

    totalOrdersGroups = ['total', 'count', 'average'];
    totalOrdersArsStats: IStats = null;
    totalOrdersUsdStats: IStats = null;

    async created() {
      const now = new Date();
      const from = new Date(now.getFullYear(), now.getMonth() - 3, 1),
        to = new Date(now.getFullYear(), now.getMonth(), now.getDate());

      const stats = await this.statsService.getIncomeStats(from, to);

      this.planStats = stats[0];
      this.orderStats = stats[1];

      const setTitle = (g: IStatGroup) => {
        const data = g.title.split('_'),
          currency = data[1],
          id = data[2];
        g.title =
          `${this.titles[id]}` + (id !== 'count' ? ` (${currency})` : '');
      };

      this.planStats.labels = [];
      this.planStats.groups.forEach((g) => setTitle(g));
      for (const stat of this.planStats.groups[0].stats) {
        this.planStats.labels.push(
          `${stat.date.substr(4, 2)}/${stat.date.substr(0, 4)}`
        );
      }

      this.orderStats.labels = [];
      this.orderStats.groups.forEach((g) => setTitle(g));
      for (const stat of this.orderStats.groups[0].stats) {
        this.orderStats.labels.push(
          `${stat.date.substr(4, 2)}/${stat.date.substr(0, 4)}`
        );
      }

      const totalOrders = await this.statsService.getTotalOrdersStats(from, to);
      this.totalOrdersArsStats = totalOrders.ars;
      this.totalOrdersUsdStats = totalOrders.usd;

      this.totalOrdersArsStats.labels = [];
      this.totalOrdersArsStats.groups.forEach(
        (g) =>
          (g.title =
            `${this.titles[g.title]}` + (g.id !== 'count' ? ' (ARS)' : ''))
      );
      for (const stat of this.totalOrdersArsStats.groups[0].stats) {
        this.totalOrdersArsStats.labels.push(
          `${stat.date.substr(4, 2)}/${stat.date.substr(0, 4)}`
        );
      }
      this.totalOrdersUsdStats.labels = [];
      this.totalOrdersUsdStats.groups.forEach(
        (g) =>
          (g.title =
            `${this.titles[g.title]}` + (g.id !== 'count' ? ' (USD)' : ''))
      );
      for (const stat of this.totalOrdersUsdStats.groups[0].stats) {
        this.totalOrdersUsdStats.labels.push(
          `${stat.date.substr(4, 2)}/${stat.date.substr(0, 4)}`
        );
      }
    }

    get filteredPlanStats() {
      if (!this.planStats) return null;

      const stats = { ...this.planStats };

      stats.groups = stats.groups.filter((value, index) =>
        value.id.endsWith(this.selectedPlanGroup)
      );

      return stats;
    }

    get filteredOrderStats() {
      if (!this.orderStats) return null;

      const stats = { ...this.orderStats };

      //stats.groups = stats.groups.filter((value, index) => this.statsActive[index]);

      return stats;
    }
  }
</script>
